import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HedaCoreUtilModule } from '@heda/core-util';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TestModule } from 'app/pechkin/test/test.module';
import { PechkinRoutingModule } from 'app/pechkin/pechkin-routing.module';
import { MessageLogListComponent } from 'app/pechkin/messagelog/containers/message-log-list.component';
import { MessageLogService } from 'app/pechkin/messagelog/services/message-log.service';
import { MessageLogViewComponent } from 'app/pechkin/messagelog/containers/message-log-view.component';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';

@NgModule({
  imports: [
    CommonModule,
    HedaCoreHospitalUiModule,
    HedaCoreUtilModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PechkinRoutingModule,
    TestModule,
  ],
  declarations: [MessageLogListComponent, MessageLogViewComponent],
  providers: [MessageLogService],
})
export class PechkinModule {}
